export default __webpack_public_path__ + "static/media/safe-travels-dt.931f5cfc.png";